import { openPhone } from 'shared/map-search/actions/callPopup';
import { openChat } from 'shared/map-search/actions/chatModal';
import { addFavorite, deleteFavorite } from 'shared/map-search/actions/favorites';
import { setSearchResultsSidebarReady } from 'shared/map-search/actions/searchResults';
import { requestContactsAccessCheck } from 'shared/map-search/reducers/earlyAccessContacts';
import { TThunkDispatch } from 'shared/map-search/types/redux';
import { callAuthenticationPopup } from 'shared/map-search/utils/authentication';

import { EChatModalOnMapActionType } from '../actions/chat';
import { EEarlyAccessContactsActionType } from '../actions/earlyAccessContacts';
import { EAddFavoritesActionTypes, EDeleteFavoritesActionTypes } from '../actions/favorites';
import { ELayoutForMapActionTypes } from '../actions/layoutForMap';
import { EPhoneActionType } from '../actions/phone';
import { ERequestAuthenticationActionType } from '../actions/requestAuthentication';
import { IReduxActionMessage } from '../types';

type TParams = {
  message: IReduxActionMessage;
  dispatch: TThunkDispatch;
  isDotPin?: boolean;
};

export function reduxActionMessageHandler({ message, dispatch, isDotPin }: TParams) {
  switch (message.value.type) {
    case EDeleteFavoritesActionTypes.Failure:
    case EAddFavoritesActionTypes.Request:
      dispatch(addFavorite(message.value.payload.offerId));
      break;
    case EDeleteFavoritesActionTypes.Request:
    case EAddFavoritesActionTypes.Failure:
      dispatch(deleteFavorite(message.value.payload.offerId));
      break;
    case EPhoneActionType.Open:
      dispatch(
        openPhone({
          builders: message.value.payload.builders,
          sellers: message.value.payload.sellers,
          gaLabel: message.value.payload.gaLabel,
          newbuildingId: message.value.payload.newbuildingId,
        }),
      );
      break;
    case ERequestAuthenticationActionType.Modal:
      callAuthenticationPopup(message.value.payload);
      break;
    case ELayoutForMapActionTypes.PostReadyMessage:
      dispatch(setSearchResultsSidebarReady(true));
      break;
    case EEarlyAccessContactsActionType.RequestContactsAccessCheck:
      dispatch(requestContactsAccessCheck(message.value.payload.offerId));
      break;
    case EChatModalOnMapActionType.Open:
      dispatch(
        openChat({
          isDotPin,
          defaultMessage: message.value.payload.defaultMessage,
          offerId: message.value.payload.offerId,
          gaLabel: message.value.payload.gaLabel,
          dealType: message.value.payload.dealType,
          offerType: message.value.payload.offerType,
          authorId: message.value.payload.authorId,
          product: message.value.payload.product,
        }),
      );
      break;
  }
}
